(function() {
    "use strict";

    let products = [];
    let intervals = [];
    window.addEventListener("resize", debounce(init));
    window.addEventListener("DOMContentLoaded", init);
    window.floatInit = init;

    function init() {
        intervals.forEach(function(interval) {
            clearInterval(interval);
        });
        intervals = [];
        products = document.querySelectorAll(".floating-anim");
        Array.prototype.forEach.call(products, function(product) {
            if (window.innerWidth < "720" || !product.offsetParent) {
                product.style.top = product.style.left = product.style.transform = "";
                return;
            }
            var containerRect = product.parentElement.getBoundingClientRect();
            var containerWidth = containerRect.width;
            var containerHeight = containerRect.height;
            var productWidth = product.clientWidth;
            var productHeight = productWidth; // assume square

            var randomXLimit = containerWidth / 2 - productWidth / 2;
            var randomYLimit = containerHeight / 2 - productHeight / 2;

            var randomX = getRandomArbitrary(-randomXLimit, randomXLimit);
            var randomY = getRandomArbitrary(-randomYLimit, randomYLimit);

            // cellCenter is the top-left pixel value that will cause the product to be placed in
            // the center of the cell.
            var cellCenterX = containerWidth / 2 - productWidth / 2;
            var cellCenterY = containerHeight / 2 - productHeight / 2;

            var offsetLeft = cellCenterX + randomX;
            var offsetTop = cellCenterY + randomY;

            var leftEdgeDifference = offsetLeft;
            var rightEdgeDifference = containerRect.width - (offsetLeft + productWidth);
            var topEdgeDifference = offsetTop;
            var bottomEdgeDifference = containerRect.height - (offsetTop + productHeight);

            if (leftEdgeDifference < 0) {
                offsetLeft += Math.abs(leftEdgeDifference);
            }
            if (rightEdgeDifference < 0) {
                offsetLeft += rightEdgeDifference;
            }
            if (topEdgeDifference < 0) {
                offsetTop += Math.abs(topEdgeDifference);
            }
            if (bottomEdgeDifference < 0) {
                offsetTop += bottomEdgeDifference;
            }

            product.style.left = `${offsetLeft}px`;
            product.style.top = `${offsetTop}px`;

            const maxRotate = 55;
            const step = getRandomArbitrary(5, 10);
            const distance = getRandomArbitrary(containerWidth / 7, containerWidth / 6);
            var state = {
                x: 0,
                y: 0,
                deg: getRandomArbitrary(0, 360)
            };

            var interval = setInterval(function() {
                state.deg += getRandomArbitrary(-maxRotate, maxRotate);

                var shift = getShift(state.deg, step);
                while (
                    Math.abs(state.x + shift.x) > distance ||
                    Math.abs(state.y + shift.y) > distance
                ) {
                    state.deg += getRandomArbitrary(-maxRotate, maxRotate);
                    shift = getShift(state.deg, step);
                }

                state.x = state.x + shift.x;
                state.y = state.y + shift.y;

                product.style.transform = `translate(${state.x}px, ${state.y}px`;
            }, 1000);
            intervals.push(interval);
        });
    }

    function getShift(deg, step) {
        return {
            x: +(Math.cos((deg * Math.PI) / 180) * step).toFixed(),
            y: +(Math.sin((deg * Math.PI) / 180) * step).toFixed()
        };
    }

    function getRandomArbitrary(min, max) {
        return +(Math.random() * (max - min) + min).toFixed();
    }
})();
